"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedVariant = void 0;
exports.EmbedVariant = {
    Tiny: "tiny",
    Compact: "compact",
    Full: "full",
    Expandable: "expandable",
};
